module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"tabListItems":{"products":"1. PRODUTOS OU SERVIÇOS","link":"2. LINK","payment":"3. FORMAS DE PAGAMENTO"}},"en-US":{"tabListItems":{"products":"1. PRODUCTS OR SERVICES","link":"2. LINK","payment":"3. PAYMENT METHODS"}}}')
  delete Component.options._Ctor
}
